import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import TestimonialModal from "./TestimonialsModal";

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchTestimonials = async () => {
    const res = await api.get("companyblog/admin/testimonials/");
    setTestimonials(res.data);
  };

  const deleteTestimonial = async (id) => {
    if (!window.confirm("Delete this testimonial?")) return;
    await api.delete(`companyblog/admin/testimonials/${id}/delete/`);
    fetchTestimonials();
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  return (
    <>
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <h5>Testimonials</h5>
        <button
          className="btn btn-primary"
          onClick={() => setShowModal(true)}
        >
          New Testimony
        </button>
      </div>

      <div className="card-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Job</th>
              <th>Feedback</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {testimonials.map((t) => (
              <tr key={t.id}>
                <td>
                  <img src={t.image} width="70" alt="" />
                </td>
                <td>{t.person_name}</td>
                <td>{t.person_occupation}</td>
                <td style={{ maxWidth: 300 }}>
                  {t.feedback}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteTestimonial(t.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      <TestimonialModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onCreated={fetchTestimonials}
      />
    </>
  );
};

export default TestimonialSection;
